export const CONDITION_MAP: Condition = {
  searchJobType: '職種',
  jobState: '勤務地',
  routeAndStation: '路線・駅',
  industry: '業種',
  employmentStatus: '雇用形態',
  income: '年収',
  kodawari: 'こだわり条件',
  holidayAndWayOfWorking: '休日・働き方',
  requirements: '募集・採用情報',
  workplaceEnvironment: '会社・職場の環境',
  welfareBenefits: '待遇・福利厚生',
  languageSkills: '語学',
  positions: '仕事内容',
  employeeAverageAge: '社員の平均年齢',
  employNum: '従業員数',
  establish: '設立',
  jobOfferKind: '応募方法',
} as const;

// storybook用
export const dummyData = {
  transitionUrl:
    'https://doda.jp/DodaFront/View/JobSearchList/j_ci__131016/-st__22564/-oc__0321M/-op__1%2C8%2C17%2C21%2C32%2C75%2C81%2C82%2C86/-ha__40%2C0/-ne__1/-es__1/-tp__0/-k__/%E5%9C%A8%E5%AE%85/-kwc__1/-ni__/%E3%83%86%E3%82%B9%E3%82%BF%E3%83%BC/-niwc__1/',
  summary:
    '[職種]プログラマ・Webサービス系エンジニア　[勤務地]千代田区　[路線・駅]大手町駅(東京都)　[雇用形態]正社員　[年収]400万円～　[こだわり]新着　[詳細条件](休日・働き方)産休・育休取得実績あり (募集・採用情報)入社後の職種変更なし (会社・職場の環境)服装自由 (語学)英語を活かす (仕事内容)管理職・マネジャー (待遇・福利厚生)U・Iターン支援あり (社員の平均年齢 )20代  (従業員数)～10名 (設立)～1年　[キーワード]「在宅」を含む、「テスター」を含まない　[応募方法]エージェントサービスの求人のみ',
  searchJobType: 'IT個人営業-IT営業、マーケティング・商品企画・広告宣伝',
  jobState: '北海道',
  routeAndStation: '東海道新幹線、二川駅',
  industry:
    'IT・通信業界、総合広告代理店-インターネット・広告・メディア業界、広告制作-インターネット・広告・メディア業界',
  employmentStatus: '正社員、契約社員、その他（FCオーナー・業務委託など）',
  income: '200万円～1000万円',
  kodawari: '職種未経験歓迎、業種未経験歓迎、学歴不問',
  includedKeyword: '求人掲載内容すべて　テストを含む',
  excludedKeyword: '勤務地　サンプルを含まない',
  detail: {
    holidayAndWayOfWorking:
      '完全週休2日制、年間休日120日以上、5日以上の連続休暇OK、原則定時退社',
    requirements: '職種未経験歓迎、業種未経験歓迎、学歴不問、第二新卒歓迎',
    workplaceEnvironment: '自動車通勤OK、服装自由',
    welfareBenefits: '退職金制度、社宅・家賃補助制度、資格取得支援制度',
    languageSkills: '英語を活かす',
    positions: '海外出張あり、管理職・マネジャー',
    employeeAverageAge: '20代、30代',
    employNum: '～10名、11～100名',
    establish: '～1年、51年～',
    jobOfferKind: '企業に直接応募する求人のみ',
  },
};

/**
 * DummyDataTypeインターフェース
 * ダミーデータの型定義
 */
export interface DummyDataType {
  /** 遷移先URL */
  transitionUrl: string | null;
  /** 概要 */
  summary: string | null;
  /** 仕事の種類 */
  searchJobType: string | null;
  /** 仕事の状態 */
  jobState: string | null;
  /** 経路と駅 */
  routeAndStation: string | null;
  /** 業種 */
  industry: string | null;
  /** 雇用形態 */
  employmentStatus: string | null;
  /** 収入 */
  income: string | null;
  /** こだわり */
  kodawari: string | null;
  /** 含めるキーワード */
  includedKeyword: string | null;
  /** 除外キーワード */
  excludedKeyword: string | null;
  /** 詳細情報 */
  detail: {
    /** 休日・働き方 */
    holidayAndWayOfWorking: string | null;
    /** 必要条件 */
    requirements: string | null;
    /** 職場環境 */
    workplaceEnvironment: string | null;
    /** 福利厚生 */
    welfareBenefits: string | null;
    /** 言語スキル */
    languageSkills: string | null;
    /** 職位 */
    positions: string | null;
    /** 従業員の平均年齢 */
    employeeAverageAge: string | null;
    /** 社員数 */
    employNum: string | null;
    /** 設立 */
    establish: string | null;
    /** 求人の種類 */
    jobOfferKind: string | null;
  } | null;
}

type Condition = Omit<
  DummyDataType,
  'detail' | 'transitionUrl' | 'summary' | 'includedKeyword' | 'excludedKeyword'
> &
  NonNullable<DummyDataType['detail']>;
